export const ENTITY_NAME = 'settings';
